import React from 'react';
import { ButtonContainer } from './SmallButtonWithIcon.styles';

export interface SmallButtonWithIconProps {
    icon: React.ReactNode;
    strokeWidth?: number;
    onPress: () => void;
}

const SmallButtonWithIcon: React.FC<SmallButtonWithIconProps> = ({
    icon,
    strokeWidth = 2,
    onPress
}) => {
    return (
        <ButtonContainer
            $strokeWidth={strokeWidth}
            onClick={onPress}>
            {icon}
        </ButtonContainer>
    );
};

export default SmallButtonWithIcon;
